import type { ConceptDef } from '../types';

export const tactColors: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-colors',
  label: 'Expressive Colors',
  category: 'Expressive',
  description: 'Show a color; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🟥', hint: 'red' },
      { prompt: '🟦', hint: 'blue' },
      { prompt: '🟩', hint: 'green' },
      { prompt: '🟨', hint: 'yellow' },
      { prompt: '🟪', hint: 'purple' },
      { prompt: '🟧', hint: 'orange' },
    ],
  },
};
